import { INVITED_PARTICIPANTS_BULK } from '../../enums'

export const tableHeaders = () => [
  {
    id: 0,
    label: '',
    intlKey: '',
    sortableId: '',
    selector: true
  },
  {
    id: 1,
    label: 'Registration ID',
    intlKey: 'table.registration_id',
    sortableId: 'participantRegistration.id'
  },
  {
    id: 2,
    label: 'First name',
    intlKey: 'table.first_name',
    sortableId: 'participantRegistration.firstName'
  },
  {
    id: 3,
    label: 'Last name',
    intlKey: 'table.last_name',
    sortableId: 'participantRegistration.lastName'
  },
  {
    id: 4,
    label: 'Invitation',
    intlKey: 'table.invitation',
    sortableId: 'participantRegistration.createdAt'
  },
  {
    id: 5,
    label: 'Level',
    intlKey: 'table.level',
    sortableId: 'participantRegistration.award.awardLevel.value'
  },
  {
    id: 6,
    label: 'Email',
    intlKey: 'table.email',
    sortableId: 'participantRegistration.email'
  },
  {
    id: 7,
    label: 'Award Centre',
    intlKey: 'table.award_unit',
    sortableId: 'organization.name'
  },
  {
    id: 8,
    label: 'Delete',
    intlKey: 'table.delete',
    sortable: false
  },
  {
    id: 9,
    label: 'Resend',
    intlKey: 'table.resend',
    sortable: false
  }
]

export const bulkInvitedParticipantsOptions = intl => {
  return [
    {
      value: INVITED_PARTICIPANTS_BULK.resendInvitationEmail.id,
      label: intl.formatMessage({ id: 'button.resend_invitation_email', defaultMessage: 'Resend invitation email' })
    },
    {
      value: INVITED_PARTICIPANTS_BULK.delete.id,
      label: intl.formatMessage({ id: 'button.delete', defaultMessage: 'Delete' })
    }
  ]
}

export const bulkForm = 'invited-participants-bulkChange'
